import { ScrollPosition } from 'react-lazy-load-image-component';
import { messageComponents, MessageType } from '../../common/chat/tools';
import { ChatMessageAndGrouped, RoomStageInfo } from '../../common/types';

export type ChatTurnProps = {
  index: number;
  length: number;
  message: ChatMessageAndGrouped;
  colorLookup?: { [key: string]: string };
  scrollPosition?: ScrollPosition;
  onLoad?: () => void;
  stages: RoomStageInfo[];
};

export function ChatTurn(props: ChatTurnProps) {
  const message = props.message;

  const index = props.index;

  let content = null;
  const colorLookup = props.colorLookup;

  if (message.type in messageComponents) {
    const Component = messageComponents[message.type as MessageType];
    content = (
      <Component
        index={index}
        length={props.length}
        message={message}
        scrollPosition={props.scrollPosition}
        onLoad={props.onLoad}
        stages={props.stages}
      />
    );
  } else {
    console.error('Unknown message type: ', message);
  }

  // const createdAt = message.createdAt ? new Date(message.createdAt).toLocaleString() : '';
  const createdAt = message.createdAt
    ? new Intl.DateTimeFormat('en-US', {
        month: 'short', // Show abbreviated month
        day: 'numeric', // Show day
        // year: 'numeric', // Show year
        hour: 'numeric', // Show hour
        minute: 'numeric', // Show minute
        hour12: true, // 12-hour format
      }).format(new Date(message.createdAt))
    : '';

  if (message.author_type === 'system') {
    return (
      <div
        key={index}
        className="message flex flex-col max-w-auto break-words rounded-tl-lg rounded-tr-lg rounded-br-lg px-2 mr-2 py-2"
      >
        <div className="flex flex-col mb-1">
          <p className="text-sm text-gray-100 font-bold">AI</p>
          <p className="text-xs text-gray-500">{createdAt}</p>
        </div>
        {content}
      </div>
    );
  }

  let color = 'bg-gray-700';
  if (colorLookup && message.user && message.user.userUuid in colorLookup) {
    color = colorLookup[message.user.userUuid];
  }
  // TODO implement different colors for different authors here
  return (
    <div
      key={index}
      className={`message flex flex-col max-w-auto break-words ${color} text-white self-end rounded-tl-lg rounded-bl-lg rounded-tr-lg custom-overflow-wrap px-4 mr-4 py-2`}
    >
      <div className="flex flex-col mb-1">
        <p className="text-sm text-gray-100 font-bold">{message.user?.name ?? ''}</p>
        <p className="text-xs text-gray-300">{createdAt}</p>
      </div>
      {content}
    </div>
  );
}
